import { useNavigate } from 'react-router-dom';

import { AppNavigation } from '@lib/types';
import { useNavigationStore } from '@stores';
import { useWebNavigationContainer } from '@providers/WebNavigationContainer';

import { Navigate, UseNavigationResult } from './types';

type ScreenPath = {
  [K in keyof AppNavigation]: string | ((params: AppNavigation[K]) => string);
};

const screenPaths: ScreenPath = {
  NewOrders: '/orders/new',
  NewOrder: ({ id }) => `/orders/new/${id}`,
  AcceptedOrder: ({ id }) => `/orders/accepted/${id}`,
  OrderHistory: ({ id }) => `/orders/history/${id}`,
  AcceptedOrders: '/orders/accepted',
  OrdersHistory: '/orders/history',
  Trips: '/trips',
  Menu: '/menu',
};

export const useNavigation = (): UseNavigationResult => {
  const { openDrawer, closeDrawer } = useWebNavigationContainer();
  const navigate = useNavigate();
  const { currentRoute, setCurrentRoute } = useNavigationStore();

  function navigateFn<K extends keyof AppNavigation>(
    to: K,
    props: AppNavigation[K],
  ) {
    const toPathDef = screenPaths[to as Extract<keyof AppNavigation, string>];
    const toPath =
      typeof toPathDef === 'function' ? toPathDef(props as never) : toPathDef;

    setCurrentRoute(to);
    navigate(toPath);
    closeDrawer();
  }

  return {
    navigate: navigateFn as Navigate,
    goBack: () => {
      navigate(-1);
    },
    openDrawer,
    closeDrawer,
    currentRoute,
  };
};
